import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';
const axios = require('axios');

export const getRefDssd = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/Sipd/get_ref_dssd`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_REF_DSSD', payload: data.Data})
            } else {
                Swal.fire('Gagal', `${data.msg}`, 'error')
            }
        })
    }
}

export const getDssd = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/Sipd/get_ref_dssd`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_DSSD', payload: data.Data})
            } else {
                Swal.fire('Gagal', `${data.msg}`, 'error')
            }
        })
    }
}

export const getDssdFinal = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/Sipd/get_dssd_final?tahun=2023`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_DSSD_FINAL', payload: data.Data})
            } else {
                Swal.fire('Gagal', `${data.msg}`, 'error')
            }
        })
    }
}
